import { 
  SET_USER_DATA,
  SET_SUBSCRIPTION_PLANS,
  TRIGER_SUBSCRIPTION_POP_UP
} from '../types';

import { setLoadSpinner, setSubscriptionPopUp, showAlert } from '../actions/uiActions';

export const setUserDataForStripe = (userData) => {
	return {
		type: SET_USER_DATA,
		payload: userData
	};
};

export const trigerSubscriptionPopUp = (isActive) => {
	return {
		type: TRIGER_SUBSCRIPTION_POP_UP,
		payload: isActive
	}
}

export const getDataSubscriptionPopUp = () => {
	return async (dispatch, getState, {getFirestore}) => {
		const firestore = getFirestore();
		const response = await firestore.collection('subscriptions').doc("hc_provider").get()
		
		const data  = response ? response.data() : {}
		dispatch(setDataSubscriptionPopUp(data))
	};
}

export const setDataSubscriptionPopUp = (data) => {
	return {
		type: SET_SUBSCRIPTION_PLANS,
		payload: data
	}
}

export const createStripeAccount = (formData) => {
  return async (dispatch, getState) => {
    dispatch(setLoadSpinner(true));
    const {stripe} = getState();
    const data = {
      email: stripe.userData.email,
      userId: stripe.userData.userId,
    };
    try {
      const response = await fetch(
        'https://us-central1-unity-61a0c.cloudfunctions.net/createStripeCustomer',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
          body: JSON.stringify(data),
        },
      );
      if (response.status === 200) {
        dispatch(addCardForStripeUser(formData));
      }
      if (response.status === 418) {
        dispatch(addCardForStripeUser(formData));
      }
    } catch (error) {
      dispatch(showAlert({type: 'error', message: 'Something goes wrong'}));
      dispatch(setLoadSpinner(false));
    }
  };
};

export const addCardForStripeUser = (formData) => {
  return async (dispatch, getState) => {
    const {stripe} = getState();
    const data = {
      card: formData.card,
      userId: stripe.userData.userId,
    };
    try {
      const response = await fetch(
        'https://us-central1-unity-61a0c.cloudfunctions.net/addCardForCustomer',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
          body: JSON.stringify(data),
        },
      );
      if (response.status === 200) {
        dispatch(addSubscriptionToUser(formData));
      }
      if (response.status === 403) {
        dispatch(setLoadSpinner(false));
        dispatch(showAlert({type: 'error', message: 'Something wrong with card'}));
      }
    } catch (error) {
      dispatch(setLoadSpinner(false));
      alert('Something goes wrong');
    }
  };
};

export const addSubscriptionToUser = (formData) => {
  return async (dispatch, getState) => {
    const {stripe} = getState();
    const data = {
      type: "Hc_provider",
      tier: formData.plan.substr(5),
      userId: stripe.userData.userId,
    };

    try {
      const response = await fetch(
        'https://us-central1-unity-61a0c.cloudfunctions.net/createSubscription',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
          body: JSON.stringify(data),
        },
        );
        if (response.status === 200) {

          dispatch(setLoadSpinner(false));
          dispatch(setSubscriptionPopUp(false));
          dispatch(showAlert({type: '', message: 'Thanks for upgrading your account to Unity Unlimited Plan!'}));

        if (response.status === 409 || response.status === 403) {
          dispatch(setLoadSpinner(false));
        }
        dispatch(setLoadSpinner(false));
      }
    } catch (error) {
      alert('Something goes wrong');
      dispatch(setLoadSpinner(false));
    }
  };
};

// export const updateCardForStripeUser = (form) => {
//   return async (dispatch, getState) => {
//     const {user} = getState();
//     try {
//       const data = {
//         card: {
//           number: String(form.cardNumber.replace(/ /g, '')),
//           month: Number(form.expiration.split('/')[0]),
//           year: Number(`${form.expiration.split('/')[1]}`),
//           cvc: String(form.cvv),
//           name: String(form.cardHolder),
//         },
//         userId: user.currentUser.userId,
//       };
//       try {
//         const response = await fetch(
//           'https://us-central1-unity-61a0c.cloudfunctions.net/updateCardForCustomer',
//           {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json;charset=utf-8',
//             },
//             body: JSON.stringify(data),
//           },
//         );
//         if (response.status === 200) {
//           RootNavigation.reset('Account');
//           dispatch(setLoading(false));
//           await dispatch(closeModal());
//         }
//         if (response.status === 403) {
//           dispatch(setLoading(false));
//           alert('Something wrong with card');
//         }
//       } catch (error) {
//         dispatch(setLoading(false));
//         alert('Something goes wrong');
//       }
//     } catch (e) {
//       alert('Something goes wrong');
//     }
//   };
// };

// export const cancelSubscription = () => {
//   return async (dispatch, getState) => {
//     const {user} = getState();
//     try {
//       const response = await fetch(
//         'https://us-central1-unity-61a0c.cloudfunctions.net/deleteSubscription',
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json;charset=utf-8',
//           },
//           body: JSON.stringify({userId: user.currentUser.userId}),
//         },
//       );
//       if (response.status === 200) {
//         RootNavigation.reset('Home');
//         dispatch(
//           setError({
//             type: 'subscription',
//             message: 'Your plan has been cancelled!',
//           }),
//         );
//         await dispatch(closeModal());
//       }
//     } catch (error) {
//       alert(error);
//     }
//   };
// };

// export const upgradeSubscription = (activePlan) => {
//   return async (dispatch, getState) => {
//     const {user} = getState();
//     const data = {
//       type: user.currentUser.role === 'patient' ? 'Individual' : 'Business',
//       tier: String(activePlan.slice(-1)),
//       userId: user.currentUser.userId,
//     };
//     dispatch(setLoading(true));
//     try {
//       const response = await fetch(
//         'https://us-central1-unity-61a0c.cloudfunctions.net/updateSubscription',
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json;charset=utf-8',
//           },
//           body: JSON.stringify(data),
//         },
//       );
//       if (response.status === 200) {
//         RootNavigation.reset('Home');
//         await dispatch(closeModal());
//         dispatch(setLoading(false));
//       }
//     } catch (error) {
//       alert(error);
//       dispatch(setLoading(false));
//     }
//   };
// };